import { Option } from "../Utilities";

export const extensionOptions: Option[] = [
  { label: "jpg", id: 1 },
  { label: "png", id: 2 },
];

export const colorOptions: Option[] = [
  { label: "srgb", id: 1 },
  { label: "p3", id: 2 },
  { label: "cmyk", id: 3 },
];
